import { texteEnLangue } from '@artosera/shared';
import { InventoryNumber } from '@artosera/ui';
import { dimensionsAffichables, formatDimensions, type Langue } from '@artosera/shared';
import type { JSX } from 'react';
import type { OeuvrePresentee } from '../api/oeuvres.js';
import styles from './ObjetCartel.module.css';

export interface ObjetCartelProps {
  titre: string;
  artiste?: string | null;
  annee?: number | string | null;
  technique?: string | null;
  precisions?: readonly (string | null | undefined)[];
  numeroInventaire?: string | null;
  taille?: 'sm' | 'md' | 'lg';
  className?: string;
}

/** Cartel d'œuvre en ligne : le titre en DM Serif Display domine, comme sur un mur. */
export function ObjetCartel({
  titre,
  artiste = null,
  annee = null,
  technique = null,
  precisions = [],
  numeroInventaire = null,
  taille = 'sm',
  className,
}: ObjetCartelProps): JSX.Element {
  const meta = [annee, technique].filter((valeur) => valeur !== null && valeur !== '').join(', ');
  const autres = precisions.filter((valeur): valeur is string => Boolean(valeur));
  return (
    <span className={[styles.cartel, className].filter(Boolean).join(' ')} data-taille={taille}>
      {artiste ? <span className={styles.artiste}>{artiste}</span> : null}
      <cite className={styles.titre}>{titre}</cite>
      {meta ? <span className={styles.meta}>{meta}</span> : null}
      {autres.length > 0 ? <span className={styles.precisions}>{autres.join(' · ')}</span> : null}
      {numeroInventaire ? (
        <InventoryNumber className={styles.inventaire} value={numeroInventaire} />
      ) : null}
    </span>
  );
}

export function proprietesCartel(
  oeuvre: Pick<
    OeuvrePresentee,
    'titre' | 'artisteNom' | 'annee' | 'technique' | 'dimensions' | 'numeroInventaire'
  >,
  langue: Langue,
): ObjetCartelProps {
  return {
    titre: oeuvre.titre,
    artiste: oeuvre.artisteNom,
    annee: oeuvre.annee,
    technique: oeuvre.technique ? texteEnLangue(oeuvre.technique, langue) : null,
    precisions: [
      oeuvre.dimensions ? formatDimensions(dimensionsAffichables(oeuvre.dimensions), langue) : null,
    ],
    numeroInventaire: oeuvre.numeroInventaire,
  };
}
